import { createReducer, on } from '@ngrx/store';
import { SetScreenSize } from '../actions/breakpoint.actions';

export interface BreakpointState {
  size: string;
}

const initialState: BreakpointState = {
  size: '',
};

export const BreakpointReducer = createReducer(
  initialState,
  on(SetScreenSize, (state, { size }) => ({
    ...state,
    size,
  }))
);
